


































import { Component, Vue, Prop, Model } from "vue-property-decorator";

/**
 * A customized form field for text input
 */
@Component
export default class Input extends Vue {
  @Prop()
  label!: string;

  @Model("input")
  value!: string | number;

  @Prop()
  name!: string;

  @Prop()
  type!: string;
}
